module.exports = __webpack_public_path__ + "static/407-424eceff289657abb49172873d9f5b23.png";